import { ReactComponent as NapsterColorLight } from 'fym-shared/src/music-services/assets/images/napster-color-light.svg';
import { ReactComponent as NapsterColorDark } from 'fym-shared/src/music-services/assets/images/napster-color-dark.svg';
import { ReactComponent as NapsterColorLightPadding } from 'fym-shared/src/music-services/assets/images/napster-color-light-padding.svg';
import { ReactComponent as NapsterColorDarkPadding } from 'fym-shared/src/music-services/assets/images/napster-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const napsterImages: MusicServiceImages = {
  logoColor: {
    light: NapsterColorLight,
    dark: NapsterColorDark,
  },
  logoColorPadding: {
    light: NapsterColorLightPadding,
    dark: NapsterColorDarkPadding,
  },
};
